<router-outlet></router-outlet>


<ngx-loading
  [show]="loading"
  [config]="{ backdropBorderRadius: '3px', fullScreenBackdrop: true }"
></ngx-loading>